import React, { useState } from "react";
import { Button as RaButton } from "react-admin";
import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

interface IEditSubsidyPercentageButton {
  onConfirmEdit: () => void;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
  smallButton: {
    minWidth: "32px",
    padding: "6px",
    backgroundColor: "#ffbf00",
    color: "black",
  },
});

const EditSubsidyPercentageButton = ({
  onConfirmEdit,
}: IEditSubsidyPercentageButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirmEdit();
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Edit Subsidy Percentage">
        <MuiButton
          size="small"
          className={classes.smallButton}
          onClick={handleOpenDialog}
        >
          <EditIcon fontSize="small" />
        </MuiButton>
      </Tooltip>

      <Dialog
        open={open}
        aria-labelledby="edit-subsidy-dialog-title"
        aria-describedby="edit-subsidy-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="edit-subsidy-dialog-title">
          Confirm Edit Student Subsidy Percentage
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to edit the current student subsidy
            percentage?
            <br />
            This change will be used only for this calculation and will{" "}
            <strong>not be permanently saved</strong> to the student's{" "}
            <strong>subsidy settings</strong>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <RaButton
            label="Back"
            color="secondary"
            onClick={handleClose}
            className={classes.cancelButton}
          />
          <RaButton label="Confirm" color="secondary" onClick={handleConfirm} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditSubsidyPercentageButton;
